import React from 'react';
import Tooltip from '@homeaway/react-tooltip';

export function PriceBar({isMobile, label, fillPercentage, monthLabel, monthPrice}) {
    return (
        <div className="PriceGraph__graph__body__item" key={label}>
            <div className="PriceGraph__graph__body__item__column">
                <Tooltip
                    wrapperClassName="PriceGraph__graph__body__item__column__fill"
                    wrapperStyle={{height: fillPercentage}}
                    centered
                    fadeOutDuration={0}
                    trigger={isMobile ? 'click' : 'hover'}
                    content={
                        <div className="PriceGraph__graph__body__item__tooltip">
                            <p className="PriceGraph__graph__body__item__tooltip__label">
                                {monthLabel}
                            </p>
                            <p className="PriceGraph__graph__body__item__tooltip__price">
                                {monthPrice}
                            </p>
                        </div>
                    }
                    placement="top"
                />
            </div>
            <div className="PriceGraph__graph__body__item__label">
                <span>{monthLabel}</span>
            </div>
        </div>
    );
}